export function getImageFromVideo(meetId: string): File | undefined {
  const video = document.getElementById(
    `meet_video_${meetId}`,
  ) as HTMLVideoElement;
  if (!video) return;
  const canvas = document.createElement('canvas');
  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;
  const ctx = canvas.getContext('2d');
  ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);
  const dataUrl = canvas.toDataURL('image/png');
  const blob = dataUrlToBlob(dataUrl);
  return new File([blob], `image_${meetId}.png`, { type: blob.type });
}

function dataUrlToBlob(dataUrl: string): Blob {
  const [header, base64] = dataUrl.split(',');
  const mimeType = header.match(/:(.*?);/)?.[1] || '';
  const byteString = atob(base64);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uintArray = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i++) {
    uintArray[i] = byteString.charCodeAt(i);
  }

  return new Blob([uintArray], { type: mimeType });
}

export async function getImageFromTrack(track: MediaStreamTrack) {
  if (!track) return '';
  const canvas = document.createElement('canvas');
  canvas.height = track.getConstraints().height as number;
  canvas.width = track.getConstraints().width as number;
  const imageCapture = new (window as any).ImageCapture(track);
  const image = await imageCapture.grabFrame();
  const ctx = canvas.getContext('2d');
  ctx?.drawImage(image, 0, 0, canvas.width, canvas.height);
  return canvas.toDataURL();
}
